import React, { useContext, useState } from "react";
import Header from "../Header/Header";
import Sidebar from "../SiderBar/SideBar";
import AuthContext from "./AuthContext";
import { NotificationProvider } from "../Notification/NotificationContext";

const MainLayout = ({ children }) => {
    const authCtx = useContext(AuthContext);
    const [isCollapsed, setIsCollapsed] = useState(false);

    return (
            <NotificationProvider>
                <div className="flex h-screen overflow-hidden">
                    {authCtx.isLoggedIn && (
                        <Sidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
                    )}
                    <div className={`flex-1 flex flex-col transition-all duration-300 ${authCtx.isLoggedIn ? (isCollapsed ? "ml-20" : "ml-64") : "ml-0"}`}>
                        <Header />
                        <main className="flex-1 p-6 bg-gray-50 overflow-auto">
                            {children}
                        </main>
                    </div>
                </div>
            </NotificationProvider>
    );
};

export default MainLayout;
